import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { CaretDown, Check } from "@phosphor-icons/react";

export const SearchableSelect = ({
  value, onChange, options = [], placeholder = "Select", allLabel = "All",
  disabled = false, testId, className = "", showAll = true,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" disabled={disabled} data-testid={testId}
          className={`justify-between font-normal ${className}`}>
          <span className={`truncate ${value ? "" : "text-muted-foreground"}`}>{value || placeholder}</span>
          <CaretDown size={14} className="opacity-60 shrink-0 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[240px]" align="start">
        <Command>
          <CommandInput placeholder="Search…" data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>No match found.</CommandEmpty>
            <CommandGroup>
              {showAll && (
                <CommandItem value="__all__" onSelect={() => { onChange(""); setOpen(false); }}>
                  <Check size={14} className={`mr-2 ${!value ? "opacity-100" : "opacity-0"}`} /> {allLabel}
                </CommandItem>
              )}
              {options.map((o, i) => (
                <CommandItem key={`${o}-${i}`} value={o} onSelect={() => { onChange(o); setOpen(false); }}
                  data-testid={testId ? `${testId}-opt-${o}` : undefined}>
                  <Check size={14} className={`mr-2 shrink-0 ${value === o ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{o}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
